import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { VcuModule } from './module/vcu/vcu.module';
import { UserModule } from './module/user/user.module';
import { ProjectModule } from './module/project/project.module';
import { DashboardModule } from './module/dashboard/dashboard.module';
import { RegisterModule } from './module/register/register.module';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpRequestInterceptor } from '../app/interceptors/http.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TranslocoRootModule } from './transloco-root.module';
import { SharedModule } from './share/share.module';
import { PublicModule } from './public/public.module';
import { AdminModule } from './module/admin/admin.module';
import { TasksModule } from './module/tasks/tasks.module';
import { SharedArchivesComponent } from './module/archives/shared-archives/shared-archives.component';
import { ArchivesModule } from './module/archives/archives.module';
import { EventsModule } from './module/events/events.module';
import { ChatbotModule } from './module/chatbot/chatbot.module';
import { TelemetryModule } from './module/telemetry/telemetry.module';
import { SocialFeedModule } from './module/social-feed/social-feed.module';
import { ForumModule } from './module/forum/forum.module';
import { AuthService } from './service/auth.service';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    VcuModule,
    UserModule,
    ProjectModule,
    RegisterModule,
    DashboardModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastModule,
    TranslocoRootModule,
    SharedModule,
    PublicModule,
    AdminModule,
    TasksModule,
    ArchivesModule,
    EventsModule,
    ChatbotModule,
    TelemetryModule,
    SocialFeedModule,
    ForumModule
  ],
  providers: [
    provideAnimations(),
    provideNgxMask(),
    provideAnimationsAsync(),
    // Root explícito: o toast global (app.component.html) e o interceptor (401 genérico,
    // ver http.service.ts) precisam compartilhar a MESMA instância de MessageService.
    // PrimeNG não registra isso em providedIn: 'root' sozinho.
    MessageService,
    {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpRequestInterceptor,
    multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () => auth.bootstrapSession(),
      deps: [AuthService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
